import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../redux/features/auth/authSlice";
import inquiriesReducer from "../redux/features/inquiries/inquiriesSlice";
import dashboardReducer from "../redux/features/dashboard/dashboardSlice";
import userReducer from "../redux/features/users/userSlice";
import staffReducer from "../redux/features/staff/staffSlice";
import courseCategoriesReducer from "../redux/features/courseCategories/courseCategoriesSlice";
import optionReducer from "../redux/features/options/optionSlice";
import organizationReducer from "../redux/features/organization/organizationSlice";
import interestReducer from "../redux/features/interest/interestSlice";
import skillReducer from "../redux/features/skill/skillSlice";
import courseReducer from "../redux/features/courses/coursesSlice";
import studentRegRequestsReducer from "../redux/features/studentRegistration/studentRegistrationSlice";
import purchaseRequestsReducer from "../redux/features/purchaseRequest/purchaseRequestSlice";
import lookupReducer from "../redux/features/lookup/lookupSlice";
import paymentReducer from "../redux/features/payment/paymentSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    courseCategory: courseCategoriesReducer,
    user: userReducer,
    staff:staffReducer,
    organization: organizationReducer,
    interest: interestReducer,
    skill: skillReducer,
    inquiry: inquiriesReducer,
    dashboard: dashboardReducer,
    option: optionReducer,
    course: courseReducer,
    studentRegRequests: studentRegRequestsReducer,
    purchaseRequest: purchaseRequestsReducer,
    lookup: lookupReducer,
    payment: paymentReducer,
  },
});

export default store;
